import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bmcore-like-outline-icon',
  templateUrl: './bmcore-like-outline-icon.component.html',
  styleUrls: ['./bmcore-like-outline-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreLikeOutlineIconComponent {
  @Input() fillColor = 'currentColor'
  @Input() width = 24
  @Input() height = 24
}
